import { render, staticRenderFns } from "./ModalDesignationNew.vue?vue&type=template&id=3777b34c&"
import script from "./ModalDesignationNew.vue?vue&type=script&lang=js&"
export * from "./ModalDesignationNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports